import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, V1 } from "@/lib/api";
import { Newspaper, Clock, ArrowRight } from "lucide-react";

export default function SchoolBlogPosts({ school }) {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    if (!school?.id) return;
    api.get(`${V1}/blog?school_id=${school.id}&limit=8`)
      .then((r) => setPosts(r.data?.items || []))
      .catch(() => {});
  }, [school?.id]);

  if (posts.length === 0) return null;

  return (
    <section data-testid="school-blog-section" className="pt-4">
      <div className="flex items-center gap-2 mb-4">
        <Newspaper className="h-5 w-5 text-primary" />
        <h2 className="font-display text-2xl font-bold">{school.name} Hakkında Yazılar</h2>
      </div>
      <p className="text-sm text-muted-foreground mb-6">
        Editör ekibimizin bu okul için hazırladığı içerikler.
      </p>
      <div className="grid md:grid-cols-2 gap-4">
        {posts.map((p) => (
          <Link
            key={p.id}
            to={`/blog/${p.slug}`}
            className="group flex gap-3 p-4 rounded-xl border border-border bg-card hover:border-primary/40 transition"
            data-testid={`school-blog-${p.id}`}
          >
            {p.cover_url && (
              <img src={p.cover_url} alt={p.title} className="h-24 w-32 object-cover rounded shrink-0 group-hover:scale-105 transition duration-500" />
            )}
            <div className="flex-1 min-w-0">
              <div className="text-[10px] uppercase tracking-widest text-accent">{p.category}</div>
              <div className="font-display font-bold leading-snug group-hover:text-primary transition line-clamp-2">{p.title}</div>
              {p.excerpt && <div className="text-xs text-muted-foreground line-clamp-2 mt-1">{p.excerpt}</div>}
              <div className="mt-2 flex items-center gap-3 text-[10px] text-muted-foreground">
                <span className="flex items-center gap-1"><Clock className="h-3 w-3" /> {p.read_minutes || 5} dk</span>
                <span className="flex items-center gap-1 text-primary font-medium">Oku <ArrowRight className="h-3 w-3" /></span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
